import React from 'react';

const SupportResistanceChart = ({ currentPrice, support, resistance, height = 60 }) => {
  // Parse values
  const price = parseFloat(currentPrice) || 0;
  const supportLevel = parseFloat(support) || price * 0.95;
  const resistanceLevel = parseFloat(resistance) || price * 1.05;

  // Calculate position percentage
  const range = resistanceLevel - supportLevel;
  const positionPercent = range > 0 ? ((price - supportLevel) / range) * 100 : 50;
  const clampedPosition = Math.max(0, Math.min(100, positionPercent));

  const formatPrice = (val) => {
    const num = parseFloat(val);
    if (num >= 1000) return `$${num.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
    if (num >= 1) return `$${num.toFixed(2)}`;
    return `$${num.toFixed(4)}`;
  };

  return (
    <div className="sr-chart" style={{ padding: '10px 0' }}>
      {/* Labels */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '12px' }}>
        <span style={{ color: '#10b981' }}>Support: {formatPrice(supportLevel)}</span>
        <span style={{ color: '#ef4444' }}>Resistance: {formatPrice(resistanceLevel)}</span>
      </div>

      {/* Chart bar */}
      <div style={{
        position: 'relative',
        height: `${height}px`,
        background: 'linear-gradient(90deg, rgba(16,185,129,0.2) 0%, rgba(245,158,11,0.2) 50%, rgba(239,68,68,0.2) 100%)',
        borderRadius: '8px',
        overflow: 'visible'
      }}>
        {/* Support line */}
        <div style={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: '3px',
          background: '#10b981',
          borderRadius: '3px 0 0 3px'
        }} />

        {/* Resistance line */}
        <div style={{
          position: 'absolute',
          right: 0,
          top: 0,
          bottom: 0,
          width: '3px',
          background: '#ef4444',
          borderRadius: '0 3px 3px 0'
        }} />

        {/* Current price marker */}
        <div style={{
          position: 'absolute',
          left: `${clampedPosition}%`,
          top: '50%',
          transform: 'translate(-50%, -50%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          <div style={{
            width: '12px',
            height: '12px',
            background: 'white',
            borderRadius: '50%',
            border: '3px solid var(--primary-color, #6366f1)',
            boxShadow: '0 0 10px rgba(99, 102, 241, 0.5)'
          }} />
          <div style={{
            marginTop: '4px',
            padding: '2px 6px',
            background: 'rgba(99, 102, 241, 0.9)',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: '600',
            whiteSpace: 'nowrap'
          }}>
            {formatPrice(price)}
          </div>
        </div>
      </div>

      {/* Zone labels */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: '8px',
        fontSize: '11px',
        color: 'rgba(255,255,255,0.5)'
      }}>
        {positionPercent < 30 && <span>Near Support Zone</span>}
        {positionPercent >= 30 && positionPercent <= 70 && <span>Mid Range</span>}
        {positionPercent > 70 && <span>Near Resistance Zone</span>}
      </div>
    </div>
  );
};

export default SupportResistanceChart;
